import { useEffect, useRef } from "react";

import { useAppInitialization } from "@hooks/use-app-initialization";

import { Center, Spinner } from "@chakra-ui/react";


import { Toaster } from "@components/ui/toaster";

import { default as monday, default as mondaySdk } from "@monday/sdk";


import Router from "./router";

export const App = () => {
  // prettier-ignore
  const { isLoading, mondayAccountId, hasPaidSubscription, isTrial, isActive,  stage } = useAppInitialization();

  const valueCreatedSent = useRef(false);

  useEffect(() => {
    if (isLoading || valueCreatedSent.current) return;

    monday.execute("valueCreatedForUser");
    valueCreatedSent.current = true; // prevent re-firing
  }, [isLoading]);

  if (isLoading || !mondayAccountId) {
    return (
      <Center height="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }


  return (
    <>


      <Router
        hasPaidSubscription={hasPaidSubscription}
        isTrial={isTrial}
        isActive={isActive}
        stage={stage!}
      />

      <Toaster />


      {/* {import.meta.env.MODE !== "production" && <Toolbar />} */}
    </>
  );
};
